var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5C0 7.76125 2.26684 10 5.05146 10C7.84114 10 10.1029 7.75625 10.1029 5C10.1029 2.23875 7.83608 0 5.05146 0C2.26179 0 0 2.24375 0 5ZM1.01029 5C1.01029 2.93313 2.9589 1 5.05146 1C7.13961 1 9.09264 2.92875 9.09264 5C9.09264 7.06687 7.14403 9 5.05146 9C2.96332 9 1.01029 7.07125 1.01029 5ZM7.07205 3.5L6.5669 3L5.05146 4.5L3.53603 3L3.03088 3.5L4.54632 5L3.03088 6.5L3.53603 7L5.05146 5.5L6.5669 7L7.07205 6.5L5.55661 5L7.07205 3.5Z",
    fill: "#D00000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncorrect);
export default __webpack_public_path__ + "static/media/incorrect.7274062204d06e99e8fb2549a7a09c43.svg";
export { ForwardRef as ReactComponent };